import React from 'react';
import ReviewAction from './ReviewAction'; // 분리한 컴포넌트 import
import '../styles/StoryViewer.css';

const StoryViewer = ({ story, issueId }) => {
  if (!story) return null;

  return (
    <article className="story-viewer">
      <div className="story-title-group">
        <h2 className="display-title">{story.title}</h2>
        <p className="display-author">{story.author}</p>
      </div>

      <div className="story-main-body">{story.body}</div>

      {/* 작가의 말 섹션 */}
      {story.authorNote && (
        <section className="author-note-wrapper">
          <div className="note-divider" />
          <h4 className="note-label">작가의 말</h4>
          <p className="note-text">{story.authorNote}</p>
        </section>
      )}

      {/* 디자인의 버튼 컴포넌트 호출 */}
      <ReviewAction issueId={issueId} currentStory={story} />
    </article>
  );
};

export default StoryViewer;
